import { render, staticRenderFns } from "./tenderTrain.vue?vue&type=template&id=e27551b4&scoped=true&"
import script from "./tenderTrain.vue?vue&type=script&lang=js&"
export * from "./tenderTrain.vue?vue&type=script&lang=js&"
import style0 from "./tenderTrain.vue?vue&type=style&index=0&id=e27551b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27551b4",
  null
  
)

export default component.exports